import { ISterilisationMachine } from '@principle-theorem/principle-core/interfaces';
import { AtLeast } from '@principle-theorem/shared';

export class SterilisationMachine {
  static init(
    overrides: AtLeast<ISterilisationMachine, 'name' | 'practice'>
  ): ISterilisationMachine {
    return {
      id: '',
      description: '',
      deleted: false,
      ...overrides,
    };
  }
}
